<!--component for RankZone Overview page-->
<template>
  <router-link class="more-details" :to="to">
    <span class="more-details__label">{{label}}</span>
    <svg width="15"
         height="15">
      <path d="M 7 1 L 1 1 L 1 14 L 14 14 L 14 8 M 14 6 L 14 1 L 9 1 M 14 1 L 5 10" />
    </svg>
  </router-link>
</template>

<script>
  import Overview from '../features/reports/rank-zone/overview/Overview'

  /**
   * Widget for RankZone {@link Overview} component
   */
  export default {
  name: 'BaseMoreDetailsLink',
  props: {
    label: {
      type: String,
      default: 'More detail'
    },
    to: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.more-details {
  display: flex;
  align-items: center;
  color: $rfx-silver;
  text-decoration: none;

  &__label {
    font-size: 12px;
    color: inherit;
    margin-right: 8px;
  }

  path {
    color: $rfx-silver;
    stroke: currentColor;
    stroke-width: 2px;
    fill: none;
  }

  &:hover {
    color: $rfx-bright-blue;

    path {
      color: $rfx-bright-blue;
    }
  }
}
</style>
